import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const MAX_CREDITS = 100;

const CreditsBar = ({ credits }) => {
  const pct = Math.min(100, (credits / MAX_CREDITS) * 100);
  const color = credits === 0 ? 'bg-red-500' : credits <= 10 ? 'bg-amber-400' : 'bg-green-500';
  const textColor = credits === 0 ? 'text-red-600' : credits <= 10 ? 'text-amber-600' : 'text-green-700';

  return (
    <div className="bg-white border border-gray-200 rounded-xl px-4 py-3 shadow-sm">
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-xs font-bold text-gray-600 flex items-center gap-1">
          <SafeIcon icon={FiIcons.FiZap} className="text-yellow-500" /> Recording Credits
        </span>
        <span className={`text-sm font-bold ${textColor}`}>{credits} left</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className={`${color} h-2 rounded-full transition-all duration-500`}
          style={{ width: `${pct}%` }}
        />
      </div>
      {credits === 0 && (
        <p className="text-xs text-red-600 mt-2 font-semibold flex items-center gap-1">
          <SafeIcon icon={FiIcons.FiAlertTriangle} /> No credits — recording disabled
        </p>
      )}
      {credits > 0 && credits <= 10 && (
        <p className="text-xs text-amber-600 mt-1.5">⚠️ Low credits — {credits} remaining</p>
      )}
    </div>
  );
};

export default CreditsBar;